import * as Sentry from '@sentry/browser'
import { persistor } from 'store'
import { showError } from 'store/entities/analytics/actions'

/**
 * Sends crash reports as state is updated and listeners are notified.
 */
export default store => next => action => {
  try {
    return next(action)
  } catch (err) {
    // console.error('Caught an exception by crush reporter!', err)
    Sentry.withScope(scope => {
      scope.setExtra('where error was happen', 'AsyncRouter')
      Sentry.captureException(err)
    })
    persistor.flush()
    store.dispatch(showError(err))
  }
}
